import { DocumentNode, gql } from '@apollo/client/core';

export const GET_HOMEPAGE: DocumentNode = gql`
  query GetHomePage(
    $isMobile: Boolean!
    $tags: [String]
    $orderCount: Int
    $previewUrl: String
  ) {
    getHomePage(
      isMobile: $isMobile
      tags: $tags
      orderCount: $orderCount
      previewUrl: $previewUrl
    ) {
      uid
      condition
      feature_flag_key
      ab_test_slices {
        uid
        slice_type
        items
        primary
      }
      slices {
        uid
        slice_type
        items
        primary
      }
    }
  }
`;
